/*
  The event bus handles the communication between components.
*/
import Vue from 'vue';
export const EventBus = new Vue();
